const Input = (props) => {
  const { name, validation, renderFunc, setValue, register, handleSubmit, watch, control, className, icon, error, label, placeholder, mb, as, type, iconTitle, onIconClick, ...rest } = props
  const pholder = placeholder === " " ? label : placeholder
  return (
    <div className={`${icon ? "input" : "form"}-group mb-${mb}`}>
      {label && <label>{label}</label>}
      {as === 'textarea' || type === 'textarea' ? (
        <textarea
          {...register(name, validation)}
          className={`form-control ${error ? "is-invalid" : ""} ${className}`}
          placeholder={pholder}
          {...rest}
        />
      ) : (
        <input
          type={type}
          {...register(name, validation)}
          className={`form-control ${error ? "is-invalid" : ""} ${className}`}
          placeholder={pholder}
          {...rest}
        />
      )}
      {icon && <div className="input-group-append">
        {onIconClick ? (
          <button
            type="button"
            className="input-group-text"
            title={iconTitle}
            onClick={onIconClick}
            style={{ cursor: "pointer" }}
          >
            <span className={`fas ${icon}`} />
          </button>
        ) : (
          <div className="input-group-text">
            <span className={`fas ${icon}`} />
          </div>
        )}
      </div>}
      {error && <span className="error invalid-feedback">{error}</span>}
    </div>
  );
};

Input.defaultProps = {
  register: () => { },
  setValue: () => { },
  name: "",
  validation: {},
  icon: "",
  className: "",
  error: "",
  label: "",
  placeholder: " ",
  mb: 3,
  as: "",
  iconTitle: "",
  onIconClick: null,
}

export default Input;
